import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

import '@elvia/elvis-accordion';
import '@elvia/elvis-outline';
import '@elvia/elvis-progress-linear';
import '@elvia/elvis-toast';

import './configureIcons';

bootstrapApplication(AppComponent, appConfig).catch((err: unknown) => {
  console.error(err);
});
